module.exports = __webpack_public_path__ + "img/auth_educloud.823ba83a.svg";